export default "__VITE_PUBLIC_ASSET__b30e8087__"